import { ChangeDetectorRef, Component, forwardRef, ViewEncapsulation, OnChanges, Input, Injector, OnInit, SimpleChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CoreDataSearcher, CoreDataSearchers } from '@jms/tenant/module.jms.core.data';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { tap } from 'rxjs/operators';
import { BasePickerComponent, PickerDisplay, PickerFetch } from '../base/base.picker.component';
import { RoleEntity } from '@jms/model';

export const ROLE_PICKER_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SecurityRolePickerComponent),
    multi: true
};

@UntilDestroy()
@Component({
    selector: 'role-picker',
    templateUrl: './role.picker.component.html',
    styleUrls: ['./role.picker.component.less'],
    encapsulation: ViewEncapsulation.None,
    providers: [ROLE_PICKER_VALUE_ACCESSOR],
    standalone: false
})
export class SecurityRolePickerComponent extends BasePickerComponent<RoleEntity, CoreDataSearcher<RoleEntity>> implements OnChanges, OnInit {

    @Input() public type = null;
    @Input() public multiple = false;

    constructor(private searchers: CoreDataSearchers, cdr: ChangeDetectorRef, injector: Injector) {
        super(cdr, injector);
        this.placeholder = this.multiple ? '<Roles>' : '<Role>';
        this.display = PickerDisplay.Always;
    }

    ngOnInit() {
        super.ngOnInit();

        this.control.valueChanges
            .pipe(
                untilDestroyed(this),
                tap(x => this.notifyValueChange())
            )
            .subscribe();

        const searcher = this.getSeacher();
        if (searcher) {
            this.getSeacher()
                .data$
                .pipe(
                    untilDestroyed(this),
                    tap(x => {
                        this.data = this.fetch === PickerFetch.Automatic ? x : this.data;
                    })
                )
                .subscribe();
        }
    }

    protected registerSearcher(): CoreDataSearcher<RoleEntity> {
        switch (this.type) {
            case 'Employee': {
                return this.searchers.getEmployeeRoles();
            }
            case 'Subcontractor': {
                return this.searchers.getSubcontractorRoles();
            }
            case 'Client': {
                return this.searchers.getClientRoles();
            }
        }
    }

    protected search(searcher: CoreDataSearcher<RoleEntity>, filter?: any): void {
        if (searcher)
            searcher.search(filter ? filter : '');
    }
}
